const COMPONENT_NAME = "MarketingTypography";
export {
  COMPONENT_NAME
};
